import React from 'react';
import { ChatCommonData, ChatCommonDataContext } from './common-data-context';
import { messageRegistry } from './index';
import { MESSAGE_TYPE_IDS } from './types';

const RegistrationProviders = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  return MESSAGE_TYPE_IDS.reduceRight<React.JSX.Element>((acc, id) => {
    const reg = messageRegistry[id];
    return reg?.Provider ? <reg.Provider>{acc}</reg.Provider> : acc;
  }, children as React.JSX.Element);
};

interface ChatRegistryProviderProps {
  // commonData should be memoized by the caller before being passed in.
  // This component does not wrap it in useMemo to avoid double-memoization.
  commonData: ChatCommonData;
  children: React.ReactNode;
}

export const ChatRegistryProvider = ({
  commonData,
  children,
}: ChatRegistryProviderProps): React.JSX.Element => {
  return (
    <ChatCommonDataContext.Provider value={commonData}>
      <RegistrationProviders>{children}</RegistrationProviders>
    </ChatCommonDataContext.Provider>
  );
};
